import { render, staticRenderFns } from "./ApprActPop.vue?vue&type=template&id=131e37d8&scoped=true"
import script from "./ApprActPop.vue?vue&type=script&lang=js"
export * from "./ApprActPop.vue?vue&type=script&lang=js"
import style0 from "./ApprActPop.vue?vue&type=style&index=0&id=131e37d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e37d8",
  null
  
)

export default component.exports